import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img14.png";
import Recpiesimg4 from "../../img9.png";
import Recpiesimg5 from "../../img3.png";
import Img1 from "./img1.png";
// import Timer from "../timer.png";
// import "../recipe.css";
const Mixvegparatha = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Mix Veg Paratha"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi Maida (all-purpose flour)</span>{" "}
            </li>
            <li>Oil</li>
            <li>Water</li>
            <li>Salt </li>
            <li>Ginger Garlic Paste</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>2 cups</li>
            <li>2 tablespoons</li>
            <li> 2 large</li>
            <li>2 tablespoons</li>
            <li>1 tablespoon</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>Boiled and mashed potatoes</li>
            <li> Chopped onions</li>
            <li>Chopped coriander</li>
            <li>Teaspoon cumin powder </li>
            <li>Finely chopped green chilies</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>1 cup</li>
            <li>1/2 cup </li>
            <li> 1/4 cup</li>
            <li>1/2 tablespoon</li>
            <li>1 tablespoon</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              In a mixing bowl, combine Nandi maida, salt, and oil. Gradually
              add water and knead to form a smooth and soft dough. Cover the
              dough and let it rest for about 15-20 minutes.
            </li>
            <li>
              In a separate bowl, mix together mashed potatoes, chopped onions,
              coriander leaves, green chilies, cumin powder, garam masala, and
              salt. This is your stuffing.
            </li>
            <li>
              Divide the dough into equal portions and roll each portion into a
              ball.
            </li>
            <li>
              Take one ball of dough, roll it into a small disc, and place a
              portion of the potato stuffing in the center.
            </li>
            <li>Seal the edges of the dough to form a stuffed ball.</li>
            <li>
              Flatten the ball with your hands and roll it out gently into a
              round paratha.
            </li>
            <li>
              Heat a griddle or a tawa over medium heat. Place the rolled
              paratha on the hot griddle.
            </li>
            <li>
              Cook one side until you see bubbles forming, then flip the paratha
              and cook the other side.
            </li>
            <li>
              Apply ghee or oil on both sides of the paratha and cook until
              golden brown spots appear.
            </li>
            <li>
              Repeat the process for the remaining dough balls and stuffing.
            </li>
            <li>
              Serve hot Maida Parathas with yogurt, pickles, or your favorite
              chutney.
            </li>
          </ol>
        }
        Item1="Atta Momos"
        Item2="Sooji Dhokla"
        Item3="Biscuit"
        Link1="wholeattavegmomos"
        Link2="soojidhokla"
        Link3="wholeattacookies"
      />
      {/*     
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For the Dough:</div>
            <ol>
              <li>
                2 cups{" "}
                <span className="Bold">Nandi Maida (all-purpose flour)</span>{" "}
              </li>
              <li>Water (as needed for kneading)</li>
              <li>1 tablespoon oil</li>
              <li>Salt to taste</li>
            </ol>
          </div>
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For the Stuffing:</div>
            <ol>
              <li>1 cup boiled and mashed potatoes</li>
              <li>1/2 cup finely chopped onions</li>
              <li>1/4 cup chopped coriander leaves</li>
              <li>1 teaspoon finely chopped green chilies (adjust to taste)</li>
              <li>1/2 teaspoon cumin powder</li>
              <li>1/2 teaspoon garam masala</li>
              <li>Salt to taste</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
          Nandi Maida 
          </div>
        </div>
        
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              In a mixing bowl, combine Nandi maida, salt, and oil. Gradually
              add water and knead to form a smooth and soft dough. Cover the
              dough and let it rest for about 15-20 minutes.
            </li>
            <li>
              In a separate bowl, mix together mashed potatoes, chopped onions,
              coriander leaves, green chilies, cumin powder, garam masala, and
              salt. This is your stuffing.
            </li>
            <li>
              Divide the dough into equal portions and roll each portion into a
              ball.
            </li>
            <li>
              Take one ball of dough, roll it into a small disc, and place a
              portion of the potato stuffing in the center.
            </li>
            <li>Seal the edges of the dough to form a stuffed ball.</li>
            <li>
              Flatten the ball with your hands and roll it out gently into a
              round paratha.
            </li>
            <li>
              Heat a griddle or a tawa over medium heat. Place the rolled
              paratha on the hot griddle.
            </li>
            <li>
              Cook one side until you see bubbles forming, then flip the paratha
              and cook the other side.
            </li>
            <li>
              Apply ghee or oil on both sides of the paratha and cook until
              golden brown spots appear.
            </li>
            <li>
              Repeat the process for the remaining dough balls and stuffing.
            </li>
            <li>
              Serve hot Maida Parathas with yogurt, pickles, or your favorite
              chutney.
            </li>
          </ol>
        </div>
      </div>
    
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/wholeattavegmomos">
              <img src={Recpiesimg3} alt="Recpiesimg3" />
              <div className="singleRecipeEndItemTitle">
                Whole Atta Veg Momos
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/wholeattacookies">
              <img src={Recpiesimg4} alt="Recpiesimg4" />
              <div className="singleRecipeEndItemTitle">Whole Atta Cookies</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/sojivegcheela">
              <img src={Recpiesimg5} alt="Recpiesimg5" />
              <div className="singleRecipeEndItemTitle">
                Sooji and Vegitable Cheela
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer />  */}
    </>
  );
};

export default Mixvegparatha;
